import { useParams } from "react-router-dom";
import DatasetCollaborators from "datasets/types/interfaces/collaborators";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

// `id` overrides the route-fetched dataset — used outside the
// `/datasets/:datasetId` route tree (e.g. the session context sidebar).
// `enabled = false` skips the fetch entirely (e.g. a read-only embed that
// never renders collaborator data) while still calling the hook itself
// unconditionally, as React requires.
const useCollaborators = (id?: string, enabled = true) => {
  const { datasetId = id } = useParams();
  return useFetcher<DatasetCollaborators>(
    datasetId && enabled ? `${VITE_CATALOG_API}/datasets/${datasetId}/users` : null,
    { revalidateOnFocus: false, errorRetryCount: 0, errorRetryInterval: 0 }
  );
};

export default useCollaborators;
